/*eslint-disable */
const $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'sa-organization-user-update',
  components: {},
  props: [],
  data() {
    return {
      submitted: false,
      first_name: '',
      last_name: '',
      email: '',
      division: '',
      activeStatus: Boolean,
      orgUserInfo: {},
      area_of_work:'',
      department:'',
      designation:''
    }
  },
  computed: {
    ...mapGetters([
      'SaorgUserDetailsByIdGetters'
    ]),
    getUserInfoByIdFun() {
      this.orgUserInfo = this.$store.getters.SaorgUserDetailsByIdGetters.data
      return
    },
    SetIntialStatus() {
      if (this.orgUserInfo != undefined) {
        this.first_name = this.orgUserInfo.first_name
        this.last_name = this.orgUserInfo.last_name
        this.email = this.orgUserInfo.email
        this.area_of_work = this.orgUserInfo.profile.area_of_work
        this.department = this.orgUserInfo.profile.department
        this.designation = this.orgUserInfo.profile.designation
        this.division = this.orgUserInfo.profile.division
        this.activeStatus = this.orgUserInfo.is_active
      }
    }
  },
    mounted() {
      this.getUserInfoByIdFun
      this.SetIntialStatus
    },
    methods: {
      validateBeforeSubmit(e) {
        this.$validator.validateAll().then((result) => {
          this.submitted = true;
          if (result) {
            let data = {
              email: this.email,
              first_name: this.first_name,
              last_name: this.last_name,
              profile: {
                area_of_work: this.area_of_work,
                department: this.department,
                designation: this.designation,
                division: this.division
              },
              is_active:this.activeStatus
            }
            this.$store.dispatch('updateSaOrgUseDetailsByIdFun', {
              data: {
                data: data,
                id: this.$route.params.saUserId
              }
            })
              .then((res) => {
                  toast.success(res.data.msg);
                  this.$router.push('/sa/organization/')
              }).catch((err) => {
                toast.error(err.data.data.email);
              })
            return;
          }
        });
      }
    },
    watch: {
      getUserInfoByIdFun() {
        return this.$store.getters.SaorgUserDetailsByIdGetters.data
      },
      SetIntialStatus() {
        if (this.orgUserInfo != undefined) {
          this.first_name = this.orgUserInfo.first_name
          this.last_name = this.orgUserInfo.last_name
          this.email = this.orgUserInfo.email
          this.area_of_work = this.orgUserInfo.profile.area_of_work
          this.department = this.orgUserInfo.profile.department
          this.designation = this.orgUserInfo.profile.designation
          this.division = this.orgUserInfo.profile.division
          this.activeStatus = this.orgUserInfo.is_active
        }
      }
    }
}